import React from 'react';
import {BlockBase, ContentData} from '../../interfaces';
import {getContentValue, isBlockTypeCorrect} from '../../utils.ts';
import {useServerProvider} from "../../use-server-provider.tsx";

interface ApplyButtonContentData {
    label: string;
}

const ApplyButtonBlock: React.FC<{ block: BlockBase<never, ApplyButtonContentData>, contentData?: ContentData<ApplyButtonContentData> | null, editable?: boolean, locale: string, fallbackLocale: string }> = ({ block, contentData, editable = false, locale, fallbackLocale }) => {
  const { id } = block;
  const onContentChange = useServerProvider<(blockId: string, field: string, value: any) => void>('onContentChange')

  if (!isBlockTypeCorrect(block, 'applyButtonBlock')) {
    return null
  }

  const { label } = getContentValue(locale, fallbackLocale, block, contentData)

  if (!label) {
    return null;
  }
  const handleInput = ({currentTarget}: {currentTarget: EventTarget | null}) => {
    if (onContentChange) {
      const {innerHTML} = currentTarget as HTMLInputElement;
      onContentChange.value(id, 'label', innerHTML);
    }
  };

  return <a className={`apply-link`} key={id} href="#" onClick={event => event.preventDefault()} onInput={handleInput} contentEditable={editable} suppressContentEditableWarning={true} data-block-id={id} data-field="label">{label}</a>;
};

export default ApplyButtonBlock;
